import { defineComponent } from 'vue'
import type { ExtractPropTypes, PropType } from 'vue'

export const edittableColumnSingleselectProps = () => ({
  head: String,
  headAlign: String as PropType<'left' | 'right' | 'center'>,
  bodyAlign: String as PropType<'left' | 'right' | 'center'>,
  name: String,
  width: [String, Number],
  fixed: [Boolean, String],
  // 是否可编辑
  editable: Boolean,
  cellEditable: Boolean,
  // code
  code: [String, Array] as PropType<string | { value: string; content: string }[] | ((row: any) => { value: string; content: string }[])>,
  // input属性
  placeholder: String,
  clearable: Boolean,
  filterable: Boolean,
})

export type EdittableColumnSingleselectProps = Partial<ExtractPropTypes<ReturnType<typeof edittableColumnSingleselectProps>>>

export default defineComponent({
  name: 'OEdittableColumnSingleselect',
  inheritAttrs: false,
  props: edittableColumnSingleselectProps(),
  setup(props, { slots, attrs, emit, expose }) {
    return () => null
  },
})
